import ErrorColumnTitle from 'common/components/ErrorColumnTitle';
import React from 'react';
import errorMessages from './errorMessages';
import './massiveUploadTableColumns.css';

const columnsCAC = [
  {
    key: 'phase',
    title: (
      <>
        <ErrorColumnTitle errorMessages={errorMessages} />
      </>
    ),
    dataIndex: 'phase',
    className: 'title-masive',
  },
  {
    key: 'productName',
    title: 'Nombre de producto',
    dataIndex: 'productName',
  },
  {
    key: 'clasification',
    title: 'Clase (Segmento)',
    dataIndex: 'clasification',
  },
  {
    key: 'presentation',
    title: 'Presentación',
    dataIndex: 'presentation',
  },
  {
    key: 'packageUnits',
    title: 'Embalaje',
    dataIndex: 'packageUnits',
  },
  {
    key: 'minRequest',
    title: 'Pedido mínimo requerido (Kg/L)',
    dataIndex: 'minRequest',
  },
];
export { columnsCAC };
